export type SurveyDetailTab = 'detail' | 'sampling_plan';

export function parseSurveyDetailHash(hash: string): SurveyDetailTab {
  const raw = (hash || '').replace(/^#/, '').trim().toLowerCase();
  if (
    raw === 'rencana-pengambilan-sampling' ||
    raw === 'sampling_plan' ||
    raw === 'sampling-plan'
  ) {
    return 'sampling_plan';
  }
  return 'detail';
}

export function buildSurveyDetailHash(tab: SurveyDetailTab): string {
  return tab === 'sampling_plan' ? '#rencana-pengambilan-sampling' : '#detail';
}
